import type { AIPlan } from '@notion-training/shared';

type PlanLevel = AIPlan['levels'][number];

export function getNextActionLevel(plan: AIPlan): PlanLevel | null {
  const sortedAsc = [...plan.levels].sort((a, b) => a.level - b.level);
  const firstPriority = sortedAsc.find((l) => l.tag === 'priority');
  if (firstPriority) return firstPriority;
  const firstUseful = sortedAsc.find((l) => l.tag === 'useful');
  if (firstUseful) return firstUseful;
  return null;
}
